import { render, staticRenderFns } from "./news-marquee.vue?vue&type=template&id=3528be4d&scoped=true"
import script from "./news-marquee.vue?vue&type=script&lang=js"
export * from "./news-marquee.vue?vue&type=script&lang=js"
import style0 from "./news-marquee.vue?vue&type=style&index=0&id=3528be4d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528be4d",
  null
  
)

export default component.exports